import React from "react";
import { SearchAd } from "~assets/frontend/frame/frm-search/components/SearchAd";
export const SearchAds = ({ searchAds }) => {
    if (searchAds.length === 0) {
        return null;
    }
    return (React.createElement("div", { className: "mb-36" }, searchAds.map((item, index) => {
        return React.createElement(SearchAd, Object.assign({ key: index }, item));
    })));
};
